import React from 'react'
import { ChevronDownIcon, ChevronUpIcon } from '@hm-group/fabric-icons'
import { CTALink } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'

import styles from './ToggleFieldsLink.module.scss'
import { ToggleFieldsLinkProps } from './types'

const ToggleFieldsLink: React.FC<ToggleFieldsLinkProps> = ({
  onClick,
  shouldHideField,
  showLabel,
  hideLabel,
}) => {
  return (
    <CTALink Tag="button" onClick={onClick} className={styles.toggleFieldContainer}>
      {shouldHideField ? <ChevronDownIcon size="small" /> : <ChevronUpIcon size="small" />}
      {shouldHideField ? getLabelFromStorage(showLabel) : getLabelFromStorage(hideLabel)}
    </CTALink>
  )
}

export default ToggleFieldsLink
